import http from './http';
import type {
  Franchise,
  FranchiseListResponse,
  FranchiseFilter,
  CreateFranchiseRequest,
  FranchiseRequest,
  FranchiseRequestListResponse,
  FranchiseRequestFilter,
} from '@/types';

export const franchiseApi = {
  getGuestList: (params: FranchiseFilter) => http.get<FranchiseListResponse>('/guest-franchises', { params }).then((r) => r.data),

  getList: (params: FranchiseFilter) => http.get<FranchiseListResponse>('/franchises', { params }).then((r) => r.data),

  getById: (id: string) => http.get<{ data: Franchise }>(`/franchises/${id}`).then((r) => r.data.data),

  create: (body: CreateFranchiseRequest) => http.post<Franchise>('/franchises', body).then((r) => r.data),

  update: (id: string, body: CreateFranchiseRequest) => http.patch<Franchise>(`/franchises/${id}`, body).then((r) => r.data),

  /* ── Nhu cầu Nhượng quyền ── */
  getGuestFranchiseRequests: (params: FranchiseRequestFilter) =>
    http
      .get<FranchiseRequestListResponse>('/guest-franchise-requests', { params })
      .then((r) => r.data),

  getFranchiseRequests: (params: FranchiseRequestFilter) =>
    http
      .get<FranchiseRequestListResponse>('/franchise-requests', { params })
      .then((r) => r.data),

  getFranchiseRequestById: (id: string) =>
    http.get<FranchiseRequest>(`/franchise-requests/${id}`).then((r) => r.data),

  createFranchiseRequest: (data: any) =>
    http.post<FranchiseRequest>('/franchise-requests', data).then((r) => r.data),

  updateFranchiseRequest: (id: string, data: any) =>
    http.patch<FranchiseRequest>(`/franchise-requests/${id}`, data).then((r) => r.data),
};
